/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import { Typography } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import { withStyles } from '@material-ui/core/styles';
import AccountIcon from '@material-ui/icons/AccountCircle';
import React, { forwardRef } from 'react';
import { AppBar, MenuItemLink, UserMenu } from 'react-admin';

import AuthService from '../providers/auth-service';

const styles = {
  title: {
    flex: 1,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  spacer: {
    flex: 1,
  },
  avatar: {
    width: '24px',
    height: '24px',
  },
};

const UsernameMenu = forwardRef((props, ref) => (
  <MenuItemLink
    ref={ref}
    to={props.route || '/'}
    primaryText={props.username}
    leftIcon={<AccountIcon />}
  />
));

const ShareUserMenu = ({ classes, ...props }) => {
  let avatar = AuthService.getAvatar(),
    username = AuthService.getUsername();

  avatar = avatar ? (
    <Avatar className={classes.avatar} src={avatar} />
  ) : (
    <AccountIcon />
  );
  username = username ? (
    <UsernameMenu username={username} route="/my-profile" />
  ) : null;

  return (
    <UserMenu {...props} icon={avatar}>
      {username}
    </UserMenu>
  );
};

const ShareAppBar = ({ classes, ...props }) => {
  return (
    <AppBar {...props} userMenu={<ShareUserMenu classes={classes} />}>
      <Typography
        color="inherit"
        className={classes.title}
        id="react-admin-title"
      />
    </AppBar>
  );
};

export default withStyles(styles)(ShareAppBar);
